import { useSelector } from 'react-redux';

import {
    getTenant,
    selectIsLoggedIn,
    selectIsMember,
    useFetchPortalNotifications,
} from '@cloud/shared';

export function useNotification() {
    const isMember = useSelector(selectIsMember);
    const isLoggedIn = useSelector(selectIsLoggedIn);

    const isCloudPortal = getTenant() === 'cloud';
    const notification = useFetchPortalNotifications({
        enabled: isLoggedIn && !isCloudPortal,
        portal: isMember ? 'USER_PORTAL' : 'OWNER_PORTAL',
    });

    return notification;
}
